import { render, staticRenderFns } from "./TotalTransaction.vue?vue&type=template&id=68111b64&scoped=true&"
import script from "./TotalTransaction.vue?vue&type=script&lang=js&"
export * from "./TotalTransaction.vue?vue&type=script&lang=js&"
import style0 from "./TotalTransaction.vue?vue&type=style&index=0&id=68111b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68111b64",
  null
  
)

export default component.exports